<script lang="ts">
    import { Logout } from "@frontend/user";
    import { onMount } from "svelte";
    import { push } from "svelte-spa-router";
    
    // svelte-ignore unused-export-let
    export let params: any = {};
    
    
    let inprogress: boolean = true;
    async function logout()
    {
        inprogress = true;
        await Logout();
        inprogress = false;
    }
    
    onMount(async () => {
        await logout();
        setTimeout(() => {
            push("/user/login");
        }, 3000)
    });
    
</script>

<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
    <div class="ui segment" style="width: 350px">
        <div class="eight wide column">
            <h1 class="ui dividing centered header">Logout</h1>
            {#if inprogress}
                <div class="ui icon message">
                    <i class="notched circle loading icon"></i>
                    <div class="content">
                        <div class="header">
                            Just one second
                        </div>
                        <p>We're logging you out.</p>
                    </div>
                </div>
            {:else}
                <div class="ui positive icon message">
                    <i class="check icon"></i>
                    <div class="content">
                        <div class="header">
                            Logged out
                        </div>
                        <p>You were logged out successfully.</p>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>
  
  





